_ = require 'underscore'
makeErrorEnum = require 'app/scripts/lib/make-error-enum'
IFrameIO = require 'app/scripts/network/iframe-io'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
{ featureFlagClient } = require '@trello/feature-flag-client'
Promise = require 'bluebird'
Visibility = require 'visibilityjs'
config = require('@trello/config')

PluginIOError = makeErrorEnum 'Plugin', [
  'NotHandled'
  'Timeout'
]

module.exports = class PluginIO
  @Error: PluginIOError

  constructor: (plugin, @handlers) ->
    # this is a temporary ugly code for the fast Confluence Power Up migration
    redirectFlag = featureFlagClient.get('ecosystem.new-confluence-pup-redirect', false)
    connectorUrl = plugin.get('iframeConnectorUrl')

    if redirectFlag && plugin.id == config.confluencePowerUpId
      connectorUrl = config.confluenceConnectorUrl

    @id = plugin.id
    # special-case the callback capability since it is implemented by Trello
    # on behalf of all Power-Ups in power-up.js
    @capabilities = _.union(plugin.get('capabilities'), ['callback'])
    @iframeConnectorUrl = connectorUrl
    @icon = plugin.get('icon')
    @listing = plugin.get('listing')
    @name = plugin.get('name')
    @moderatedState = plugin.get('moderatedState')
    @public = plugin.get('public')

  getName: -> @listing?.name || @name
  getDescription: -> @listing?.description || ''
  getOverview: -> @listing?.overview || ''
  getIconUrl: ->
    iconUrl = @icon?.url
    if pluginValidators.isValidUrlForImage(iconUrl)
      iconUrl
    else
      null

  _getIo: ->
    if @moderatedState == 'moderated'
      throw new Error("Power-Up '#{@getName()}' (id: #{@id}) is moderated")

    @_io ?= new IFrameIO(@iframeConnectorUrl, @handlers, @id, @capabilities)

  request: (command, options, timeout) ->
    if @moderatedState == 'moderated'
      throw new Error("Power-Up '#{@getName()}' (id: #{@id}) is moderated")

    new Promise (resolve) ->
      # we only want to make a request to a Power-Up when the board is in the foreground tab
      # otherwise our communication with it is slowed so drastically by the browser that
      # we are highly prone to timing out. Also updating the information you aren't looking
      # at isn't terribly useful, so we'll just wait for you to be looking.
      Visibility.onVisible resolve
    .then =>
      @_getIo()
      .request(command, options, timeout)
      .catch IFrameIO.Error.NotHandled, ->
        throw PluginIOError.NotHandled()
      .catch IFrameIO.Error.Timeout, (err) ->
        throw PluginIOError.Timeout(err.message)

  supports: (command) ->
    if @moderatedState == 'moderated'
      console?.warn("Warning: Power-Up '#{@getName()}' (id: #{@id}) is moderated.
        Capability '#{command}' was denied."
      )
      return false

    _.isArray(@capabilities)? && command in @capabilities

  drop: ->
    @_getIo().then (io) ->
      io?.drop()
